const SIZE_ORDER = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'];

export async function loadCatalog(fetchImpl = fetch) {
  const response = await fetchImpl('/mangotee-templates.json');
  if (!response.ok) throw new Error(`Mango catalog returned HTTP ${response.status}`);
  return normalizeCatalog(await response.json());
}

export function normalizeCatalog(document) {
  return Object.values(document?.templates || {})
    .filter((template) => template.variants?.length)
    .map((template) => {
      const availableColors = unique(template.variants.map(({color}) => color));
      const featuredColors = unique(template.featuredColors || [])
        .filter((color) => availableColors.includes(color));
      const remainingColors = availableColors
        .filter((color) => !featuredColors.includes(color))
        .sort();
      return {
        ...template,
        featuredColors,
        colors: [...featuredColors, ...remainingColors],
        sizes: unique(template.variants.map(({size}) => size)).sort(sizeCompare),
      };
    });
}

export function selectedVariants(template, colors, sizes) {
  const colorSet = new Set(colors);
  const sizeSet = new Set(sizes);
  return template.variants.filter(
    ({color, size}) => colorSet.has(color) && sizeSet.has(size),
  );
}

export function defaultSelection(template) {
  const preferredSizes = ['S', 'M', 'L', 'XL', '2XL'];
  return {
    colors: template.featuredColors?.length
      ? [...template.featuredColors]
      : template.colors.filter((color) => color === 'BLACK' || color === 'WHITE'),
    sizes: template.sizes.filter((size) => preferredSizes.includes(size)),
  };
}

function unique(values) {
  return [...new Set(values.filter(Boolean))];
}

function sizeCompare(left, right) {
  const leftIndex = SIZE_ORDER.indexOf(left);
  const rightIndex = SIZE_ORDER.indexOf(right);
  if (leftIndex === -1 || rightIndex === -1) return left.localeCompare(right);
  return leftIndex - rightIndex;
}
